import { ReactNode, useMemo } from 'react';
import { ProviderAvailability } from '@types';
import { groupProviderAvailabilitiesByTimeBlock } from './utils';
import { AppointmentTimePreferenceContext } from './AppointmentTimePreferenceContext';

type Props = {
  availabilities: ProviderAvailability[];
  children: ReactNode;
};

export function AppointmentTimePreferenceProvider({
  availabilities,
  children,
}: Props) {
  const groupedAvailabilitiesByTimeBlock = useMemo(() => {
    return groupProviderAvailabilitiesByTimeBlock(availabilities);
  }, [availabilities]);

  const value = useMemo(
    () => ({
      availabilities,
      groupedAvailabilitiesByTimeBlock,
    }),
    [availabilities, groupedAvailabilitiesByTimeBlock],
  );

  return (
    <AppointmentTimePreferenceContext.Provider value={value}>
      {children}
    </AppointmentTimePreferenceContext.Provider>
  );
}
